


import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    airports: { type: Array as PropType<string[]>, required: true },
    carTypes: { type: Array as PropType<string[]>, required: true },
    airportName: { type: String, required: true },
    carType: { type: String, required: true },
    airportLabel: { type: String, required: true },
    carTypeLabel: { type: String, required: true },
    disabled: { type: Boolean, required: true },
  },
  emits: ['update:airportName', 'update:carType'],
  setup(_props, { emit }) {
    const updateAirportName = (airportName: string): void => {
      emit('update:airportName', airportName);
    };
    const updateCarType = (carType: string): void => {
      emit('update:carType', carType);
    };

    return {
      updateAirportName,
      updateCarType,
    };
  },
});
